import React from "react";

import { SignIn } from "@formant/auth-lib/src/components/SignIn/SignIn";

import { authClient } from "../../clients";
import { useStores } from "../../context/StoreContext";

export const Auth = () => {
    const { authStore } = useStores();

    const loginWithGoogleToken = async (
        token: string,
        autoCreateOrg: boolean,
    ) => {
        const result = await authStore.loginWithGoogleToken(
            token,
            autoCreateOrg,
        );
        return result;
    };

    const login = async (email: string, password: string) => {
        return await authStore.login(email, password);
    };

    const checkSso = async (email: string) => {
        const ssoConfig = await authClient.checkSso(email);
        return ssoConfig;
    };

    const confirmForgotPassword = async (
        email: string,
        confirmationCode: string,
        newPassword: string,
    ) => {
        return await authClient.confirmForgotPassword({
            email,
            confirmationCode,
            newPassword,
        });
    };

    const sendConfirmationCode = async (email: string) => {
        return await authClient.forgotPassword(email);
    };

    return (
        <SignIn
            login={login}
            changeStaySignedIn={value => authStore.setPersistentSession(value)}
            checkSso={checkSso}
            loginWithGoogleToken={loginWithGoogleToken}
            sendConfirmationCode={sendConfirmationCode}
            confirmForgotPassword={confirmForgotPassword}
        />
    );
};
